<template>
  <div>
    <div class="header">
      <div class="menu">
        <el-row>
          <el-col :span="12"
            ><div class="grid-content bg-purple">
              <img
                class="logo cursor"
                src="../../content/img/hdlog1.png"
                @click="home"
              /></div
          ></el-col>
          <el-col :span="10"
            ><div class="grid-content bg-purple-light home-menu">
              <div><router-link to="/">首页</router-link></div>
              <div><router-link to="/notice">会议通知</router-link></div>
             <div ><router-link :to=" !isBlank(user)?user.RoleId!='3'?'/submit':'/review':'/submit'"><span>提交与评审系统</span></router-link></div>
               <div v-if="isShowLogin" id="btn-login">
                <router-link to="/entrance">注册</router-link> /
                <router-link to="/login">登录</router-link>
              </div>
              <div class="cursor" v-else>
                <el-dropdown style="width: 220px">
                <span class="el-dropdown-link" >
                    <router-link to="/" style="font-size: 16px;">{{
                       user.RoleId == '3'?user.UserName:user.SchoolName
                    }}</router-link>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <router-link
                        to="/backIndex"
                        style="text-decoration: none; color: black"
                      >
                        <el-dropdown-item v-if="user.RoleId == '1'">
                          <img
                            src="../../content/img/edit-2-line.png"
                            width="20"
                            height="20"
                            alt=""
                          />
                          <div class="item-text">
                            后台管理
                          </div></el-dropdown-item
                        ></router-link
                      >
                      <router-link
                        to="/info"
                        style="text-decoration: none; color: black"
                        ><el-dropdown-item
                          ><img
                            src="../../content/img/survey-line.png"
                            width="20"
                            height="20"
                            alt=""
                          />
                          <div class="item-text">
                            个人中心
                          </div></el-dropdown-item
                        ></router-link
                      >
                      <el-dropdown-item @click="close"
                        ><img
                          src="../../content/img/logout-circle-line.png"
                          width="20"
                          height="20"
                          alt=""
                          style="color: black"
                        />
                        <div class="item-text">退出登录</div></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div></el-col
          >
          <el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { _local } from "../../utils/storage";
import {LoginOut} from '../../http/login'
import { ElMessage } from "element-plus";
import {  ref } from "vue";
import router from "../../router/index";
import { isBlank } from '../../utils/utils';
export default {
  setup() {
    const close = () => {
      LoginOut().then(() => {
        _local.remove("token");
        _local.remove("user");
        ElMessage({
          message: "退出成功",
          type: "success",
        });
        router.push("/login");
      });
    };
    let isShowLogin = ref(true);
    const isLogin = () => {
      if (_local.get("token")) {
        isShowLogin.value = false;
      } else {
        isShowLogin.value = true;
      }
    };
    isLogin();
     const user = _local.get("user");
    return {
      close,
      isLogin,
      user,
      isShowLogin,
      isBlank
    };
  },
};
</script>
<style lang="scss" scoped>
.header {
  height: 88px;
}
.logo {
  width: 265.9px;
  height: 48px;
  margin: 0 417.1px 0 0;
  padding: 0 34.2px 0 154.7px;
  background-color: var(--h-0-s-0-l-100);
  margin-top: 19px;
}
.menu {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 88px;
  -webkit-backdrop-filter: blur(32px);
  backdrop-filter: blur(32px);
  background-color: var(--h-0-s-0-l-100);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}
.item-text {
  width: 100px;
  height: 30px;
  float: right;
  line-height: 40px;
  margin-top: -6px;
  font-size: 14px;
  padding-left: 10px;
}
.item-text:hover {
  color: #409eff;
}
.home-menu {
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    // padding:0 5% 0 5%;
    text-align: center;
    // width: 150px;
     padding-right:60px;
    a {
      text-decoration: none;
      color: black;
      // width: 40px;
    }
  }
}
#btn-login {
  text-align: center;
  width: 122px;
  //margin: 9px 0 7px 58px;
  padding: 7px 17px;
  border: solid 1px white;
  > span {
    width: 28px;
    // height: 18px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: white;
  }
}
.cursor{
   cursor: pointer;
}
</style>